import React from 'react';
import { TableRow, TableCell, Box, Typography } from '@mui/material';

interface AdSetSeparatorProps {
  adsetName: string;
  adCount: number;
  colSpan: number;
}

/**
 * AdSetSeparator - Dotted line separator between adsets
 *
 * Displays a subtle dotted line with adset name label
 * Matches the old system's adset separator styling
 */
export const AdSetSeparator: React.FC<AdSetSeparatorProps> = ({ adsetName, adCount, colSpan }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ p: 0, border: 0 }}>
        <Box
          sx={{
            position: 'relative',
            textAlign: 'left',
            py: 1,
            px: 0.125,
          }}
        >
          {/* Primary colored line */}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              borderTop: '2px solid',
              borderColor: 'primary.main',
              opacity: 0.3,
            }}
          />

          {/* Badge with primary color */}
          <Box
            sx={{
              position: 'relative',
              left: 280, // Align with name column
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              px: 1.25,
              py: 0.5,
              fontSize: '0.75rem',
              bgcolor: 'background.paper',
              border: '1.5px solid',
              borderColor: 'primary.main',
              borderRadius: 1.5,
              maxWidth: 450,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                fontSize: '0.75rem',
                color: 'primary.main',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {adsetName}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'primary.main',
                opacity: 0.7,
                fontSize: '0.7rem',
                fontWeight: 500,
                flexShrink: 0,
              }}
            >
              {adCount} ad{adCount !== 1 ? 's' : ''}
            </Typography>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default AdSetSeparator;
